import { useMsal } from '@azure/msal-react';
import React, { useEffect, useState } from 'react';

export const UserInfo = () => {
  const { instance } = useMsal();
  const [name, setName] = useState('');

  useEffect(() => {
    const currentAccount = instance.getActiveAccount();
    if (currentAccount) {
      setName(currentAccount.name);
    }
  }, [instance]);

  return <span className="username">{name}</span>;
};
